module.exports = __webpack_public_path__ + "img/icon_candy_blue.cd63685d.svg";